import React, { Component } from 'react';
import * as styled from '../../../styles/style';

class RadioField extends Component {
  render() {
    let { values, name, labels, update, formProp, display } = this.props;
    values = Object.keys(values).map(itm => values[itm]);
    let checked;

    return (
      <styled.RadioGroup display={display}>
        {values.map((value, index) => {
          return (
            <label key={index}>
              <styled.RadioButton
                type="radio"
                name={`${name}${index}`}
                id={`${name}${index}`}
                value={value}
                onChange={update}
                checked={(parseInt(formProp, 10) === parseInt(value, 10) || formProp === value)} />
              {labels[index]}
            </label>
          );
        })}
      </styled.RadioGroup>
    )
  }
}

export default RadioField;
